export default function blobToDataUrl(blob: Blob | File): Promise<string> {
  return new Promise(resolve => {
    const reader = new FileReader()

    reader.onload = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}
